import { useEffect, useState } from "react";
import "./reportItem.scss";
import DownloadModal from "./DownloadModal";
import ViewTrendsReport from "./ViewTrendsReport";
import ViewAnalyticsReport from "./ViewAnalyticsReport";
import { toast } from "react-toastify";
import moment from "moment";
import globalErrorHandling from "../../utils/utils";
import axios from "axios";
import UpgradeIconSmall from "../../assets/images/zap-icon.svg";
import { getApiUrl } from "../../utils/baseUrl";
import { captureException } from "@sentry/react";

const intelAPIEndpoints = {
  downloadExcel: getApiUrl("create_excel_analytics_view_all"),
};

function ReportItem({ report, index, analyticsItems, setCurrentViewedIndex, currentViewedIndex, reportsLength, ...props }) {
  const { analyticsViewAllData, analyticsTrendsData, viewAllFinalSearchReqObj, hideViewAllModal, dropdownOptions, from, tradeDirection, country, twoColumnMapping, analyticsType, userCredit, analyticsRangeDownloadPresent, viewAllAPI, isViewAllGridNew, mapSelectedValue, selectedRows, defaultData, pathname, analyticsCountryID, currentUserPlan, trendsAPI, handleClose, heading, analyticsDataSource, trendsDropdownOptions } = props;
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showViewTrendsModal, setShowViewTrendsModal] = useState(false);
  const [showViewAnalyticsModal, setShowViewAnalyticsModal] = useState(false);
  const [downloadFromValue, setDownloadFromValue] = useState(1);
  const [downloadToValue, setDownloadToValue] = useState(100);
  const isAnalyticsReport = report?.report_type.toLowerCase() === "absolute";
  const isTrendsReport = report?.report_type.toLowerCase() === "trends";

  useEffect(() => {
    if (currentViewedIndex !== null) {
      if (currentViewedIndex === index) {
        if (isAnalyticsReport && !showViewAnalyticsModal) {
          getRequestObjData();
          setTimeout(() => {
            setShowViewAnalyticsModal(true);
          }, 200);
        } else if (isTrendsReport && !showViewTrendsModal) {
          getRequestObjData();
          setTimeout(() => {
            setShowViewTrendsModal(true);
          }, 200);
        }
      } else {
        setShowViewAnalyticsModal(false);
        setShowViewTrendsModal(false);
      }
    }
  }, [currentViewedIndex]);

  useEffect(() => {
    if (showDownloadModal) {
      getRequestObjData();
    }
  }, [showDownloadModal]);

  const maxDataCount = 500;

  const currentKeyViewTrendItem = analyticsItems?.find((item) => item.key === report.primary_attribute_field) ?? {};

  const handleViewClick = (e) => {
    e.preventDefault();
    getRequestObjData();
    if (isAnalyticsReport) {
      setTimeout(() => {
        setShowViewAnalyticsModal(true);
      }, 200);
    } else if (isTrendsReport) {
      setTimeout(() => {
        setShowViewTrendsModal(true);
      }, 200);
    }
    setCurrentViewedIndex(index);
  };
  const callingDownloadAPI = (isRangeViewAll = true) => {
    let existingReqObj = viewAllFinalSearchReqObj ?? {};
    existingReqObj.must_not = [];
    if (report?.is_second_level) {
      existingReqObj.isSecondLevelAnalytics = true;
      existingReqObj.subAnalyticsField = report?.secondary_attribute_field;
    } else {
      delete existingReqObj.isSecondLevelAnalytics;
      delete existingReqObj.subAnalyticsField;
    }

    if (isTrendsReport) {
      existingReqObj.isTrends = true;
      existingReqObj.trendType = report?.trend_type;
    } else {
      existingReqObj.isTrends = false;
    }

    const downloadPayload = {};

    downloadPayload._payload = existingReqObj;
    downloadPayload._payload.from = downloadFromValue - 1;
    downloadPayload._payload.size = Math.abs(downloadToValue - downloadFromValue) + 1;
    downloadPayload._payload.email = true;
    downloadPayload._payload.must_not = [];
    downloadPayload._payload.analysis = report?.analysis_on;
    downloadPayload._payload.analyticsField = report?.primary_attribute_field;

    if (report?.is_second_level) {
      downloadPayload.subAnalyticsField = report?.secondary_attribute_field;
      downloadPayload._payload.subAnalyticsField = report?.secondary_attribute_field;
    }

    if (+downloadToValue < +downloadFromValue) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }

    downloadPayload.isSecondLevelAnalytics = report?.is_second_level ? true : false;
    downloadPayload.isRangeViewAll = isRangeViewAll === true ? isRangeViewAll : false;

    downloadPayload.file_name = (isTrendsReport ? "Analytics_TrendsViewAll_" : "Analytics_ViewAll_") + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    downloadPayload.analysis = report?.analysis_on;
    downloadPayload.tradeDirection = !!tradeDirection && tradeDirection !== "" ? tradeDirection : "";
    downloadPayload.country = !!country && country !== "" ? country : "";
    if (isTrendsReport) {
      downloadPayload.headers = [];
    }
    downloadPayload.analyticsField = report?.primary_attribute_field;
    if (isRangeViewAll) {
      axios.post(intelAPIEndpoints.downloadExcel, downloadPayload).then(
        (res) => {
          if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
            toast.success(res.data.message);
            setShowDownloadModal(false);
          } else {
            globalErrorHandling(res);
          }
        },
        (error) => {
          captureException(error);
          toast.error("Something went wrong. Please try again later !!!");
        }
      );
    }
  };

  const getRequestObjData = () => {
    let summaryViewAllReqObj = {
      analyticsViewAllKey: report.primary_attribute_field,
      analysisOption: report?.analysis_on,
    };

    if (isAnalyticsReport) {
      analyticsViewAllData(summaryViewAllReqObj, currentKeyViewTrendItem, true);
    } else if (isTrendsReport) {
      analyticsTrendsData(summaryViewAllReqObj, currentKeyViewTrendItem, true);
    }
  };
  return (
    <>
      {showDownloadModal && <DownloadModal showModal={showDownloadModal} setShowModal={setShowDownloadModal} downloadFromValue={downloadFromValue} setDownloadFromValue={setDownloadFromValue} downloadToValue={downloadToValue} setDownloadToValue={setDownloadToValue} dataCount={maxDataCount} downloadRangeFilter={callingDownloadAPI} showNote />}
      <div className="report-item-container">
        {report.is_second_level && (
          <div className="two-dimensional-report">
            <span className="p-0">
              <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
            </span>
            2-dimensional report
          </div>
        )}
        <p className="item-heading">{report.report_name}</p>
        <p className="item-subheading">{report.report_description}</p>
        <div className="buttons">
          <button className="view-btn" onClick={handleViewClick}>
            <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707282581/intel/icons/xvtns8sjfvaokn7335vi.svg" alt="View all Icon" />
            View
          </button>
        </div>
      </div>
      {isTrendsReport && showViewTrendsModal && Object.keys(viewAllFinalSearchReqObj).length ? (
        <ViewTrendsReport
          index={index}
          onCloseModal={() => {
            setShowViewTrendsModal(false);
            setCurrentViewedIndex(null);
          }}
          report={report}
          viewTrendsFinalSearchReqObj={viewAllFinalSearchReqObj}
          currentKeyViewTrendItem={currentKeyViewTrendItem}
          trendsAPI={trendsAPI}
          handleClose={handleClose}
          heading={heading}
          analyticsViewAllData={analyticsViewAllData}
          dropdownOptions={dropdownOptions}
          from={from}
          tradeDirection={tradeDirection}
          country={country}
          analyticsDataSource={analyticsDataSource}
          twoColumnMapping={twoColumnMapping}
          analyticsType={analyticsType}
          userCredit={userCredit}
          trendsDropdownOptions={trendsDropdownOptions}
          analyticsRangeDownloadPresent={analyticsRangeDownloadPresent}
          pathname={pathname}
          analyticsCountryID={analyticsCountryID}
          currentUserPlan={currentUserPlan}
          setCurrentViewedIndex={setCurrentViewedIndex}
          reportsLength={reportsLength}
          currentViewedIndex={currentViewedIndex}
        />
      ) : isAnalyticsReport && Object.keys(viewAllFinalSearchReqObj).length && showViewAnalyticsModal ? (
        <ViewAnalyticsReport
          currentKeyViewTrendItem={currentKeyViewTrendItem}
          analyticsViewAllData={analyticsViewAllData}
          viewAllFinalSearchReqObj={viewAllFinalSearchReqObj}
          hideViewAllModal={hideViewAllModal}
          dropdownOptions={dropdownOptions}
          from={from}
          tradeDirection={tradeDirection}
          country={country}
          twoColumnMapping={twoColumnMapping}
          analyticsType={analyticsType}
          userCredit={userCredit}
          analyticsRangeDownloadPresent={analyticsRangeDownloadPresent}
          viewAllAPI={viewAllAPI}
          isViewAllGridNew={isViewAllGridNew}
          mapSelectedValue={mapSelectedValue}
          selectedRows={selectedRows}
          defaultData={defaultData}
          pathname={pathname}
          analyticsCountryID={analyticsCountryID}
          currentUserPlan={currentUserPlan}
          onCloseModal={() => {
            setShowViewAnalyticsModal(false);
            setCurrentViewedIndex(null);
          }}
          report={report}
          setCurrentViewedIndex={setCurrentViewedIndex}
          reportsLength={reportsLength}
          index={index}
          currentViewedIndex={currentViewedIndex}
        />
      ) : null}
    </>
  );
}

export default ReportItem;
